import React from 'react';
import { CloudOff, RefreshCw } from 'lucide-react';
import { savedAgo } from '@/lib/offlineCache';

// Amber HUD banner shown when a core read screen is rendering cached data with
// no connection. Tap to retry.
export function OfflineBanner({ savedAt, onRetry }) {
  return (
    <div
      data-testid="offline-banner"
      onClick={onRetry}
      className="flex items-center gap-3 rounded-2xl px-4 py-3 cursor-pointer"
      style={{ background: 'rgba(201,168,91,0.16)', border: '1px solid rgba(201,168,91,0.5)' }}
    >
      <CloudOff className="w-5 h-5 flex-shrink-0" style={{ color: '#1A4331' }} />
      <div className="flex-1">
        <p className="text-sm font-bold" style={{ color: '#1A4331' }}>You&apos;re offline</p>
        <p className="text-xs" style={{ color: '#4E7A33' }}>Showing your saved garden{savedAt ? ` · updated ${savedAgo(savedAt)}` : ''}</p>
      </div>
      {onRetry ? <RefreshCw className="w-4 h-4 flex-shrink-0" style={{ color: '#1A4331' }} /> : null}
    </div>
  );
}

export default OfflineBanner;
